import React from 'react';
import '../../App.css';
import CheckIcon from "mdi-react/CheckCircleOutlineIcon"
class SucessMessage extends React.Component {
    render() {
        return (
            <div>
                {this.props.isSucess ? 
                    <div className="sucess-message" style={this.props.style}>
                        <CheckIcon size={15} style={{marginRight:10}} className="error-icon sucess-color"></CheckIcon>
                        <span className="error-text sucess-color">{this.props.text || "Sucess"}</span>
                    </div>
                : null }
            </div>
        );
    }
}

export default SucessMessage